<template>
  <div class="qp-seg" role="radiogroup" :aria-label="$t('Theme')">
    <button v-for="option in options" :key="option.mode" type="button" role="radio"
      :aria-checked="theme.mode === option.mode ? 'true' : 'false'" :aria-label="$t(option.label)"
      :title="$t(option.label)" :class="{ 'is-active': theme.mode === option.mode }" class="!min-w-0 !px-2"
      @click="setThemeMode(option.mode)">
      <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <template v-if="option.mode === 'light'">
          <circle cx="8" cy="8" r="3" />
          <path d="M8 1.5v1.2M8 13.3v1.2M1.5 8h1.2M13.3 8h1.2M3.4 3.4l.85.85M11.75 11.75l.85.85M3.4 12.6l.85-.85M11.75 4.25l.85-.85" />
        </template>
        <template v-else-if="option.mode === 'dark'">
          <path d="M13.5 9.6A5.5 5.5 0 0 1 6.4 2.5a5.5 5.5 0 1 0 7.1 7.1z" />
        </template>
        <template v-else>
          <rect x="1.75" y="2.5" width="12.5" height="8.5" rx="1.2" />
          <path d="M5.5 13.5h5M8 11v2.5" />
        </template>
      </svg>
    </button>
  </div>
</template>

<script>
import { theme, setThemeMode } from "../theme";

export default {
  name: "ThemeToggle",
  data() {
    return {
      theme,
      options: [
        { mode: "system", label: "System theme" },
        { mode: "light", label: "Light theme" },
        { mode: "dark", label: "Dark theme" },
      ],
    };
  },
  methods: {
    setThemeMode,
  },
};
</script>
